import { INTERNET_CHECK_URL } from '../constants';
import { makeId } from './index';

function loadInternetImage(callback) {
  const image = document.createElement('img');
  image.onload = () => {
    callback(true);
  };
  image.onerror = () => {
    callback(false);
  };
  image.src = `${INTERNET_CHECK_URL}?${makeId(4)}`;
}

export function isOnline(callback) {
  loadInternetImage(callback);
}
